/* The Hollow Harvest · comportamenti e movimento
   Nessuna dipendenza, nessuna libreria. Tutto degrada bene senza JavaScript,
   e tutto si spegne se il visitatore ha chiesto meno animazioni. */

(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // segnala che il JS gira: gli effetti che nascondono qualcosa dipendono da questo
  document.documentElement.classList.add('hh-js');

  /* ------------------------------------------------------------ reveal ---- */
  /* Gli elementi di una stessa sezione entrano in sequenza, non tutti insieme. */
  function initReveal() {
    var items = document.querySelectorAll('.hh-reveal');
    if (!items.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var section = el.closest('section, footer, header');
        var siblings = section ? Array.prototype.slice.call(section.querySelectorAll('.hh-reveal')) : [el];
        var i = siblings.indexOf(el);
        el.style.transitionDelay = (i > 0 ? Math.min(i, 6) * 70 : 0) + 'ms';
        el.classList.add('is-in');
        observer.unobserve(el);
      });
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });

    items.forEach(function (el) { observer.observe(el); });

    /* RETE DI SICUREZZA. L'osservatore da' l'effetto a scalare, ma non e' una
       garanzia: su WebKit, misurato il 2026-09-10, trentaquattro testi
       restavano a opacita' zero per sempre, cioe' un terzo di pagina bianco su
       Safari. Qui una passata legata allo scorrimento riprende chiunque sia
       gia' entrato nello schermo e l'osservatore si sia perso. Costa niente:
       si spegne da sola quando non resta piu' nessuno. */
    var restano = Array.prototype.slice.call(items);
    var inCorso = false;

    function recupera() {
      inCorso = false;
      var h = window.innerHeight;
      restano = restano.filter(function (el) {
        if (el.classList.contains('is-in')) return false;
        if (el.getBoundingClientRect().top < h) { el.classList.add('is-in'); return false; }
        return true;
      });
      if (!restano.length) {
        window.removeEventListener('scroll', chiedi);
        window.removeEventListener('resize', chiedi);
      }
    }
    function chiedi() {
      if (inCorso) return;
      inCorso = true;
      requestAnimationFrame(recupera);
    }
    window.addEventListener('scroll', chiedi, { passive: true });
    window.addEventListener('resize', chiedi, { passive: true });
    window.addEventListener('load', chiedi);
    setTimeout(chiedi, 400);
    setTimeout(chiedi, 1600);
  }

  /* --------------------------------------------------------- countdown ---- */
  /* Conta i giorni che mancano davvero e cambia messaggio da solo quando la
     data è passata. Nessun timer che si azzera al refresh. */
  function initCountdown() {
    var nodes = document.querySelectorAll('[data-hh-countdown]');
    if (!nodes.length) return;

    var now = new Date();
    var today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());

    nodes.forEach(function (node) {
      var parts = (node.getAttribute('data-target') || '').trim().split('-');
      if (parts.length !== 3) return;

      var days = Math.round((Date.UTC(+parts[0], +parts[1] - 1, +parts[2]) - today) / 86400000);
      var before = node.querySelector('[data-hh-before]');
      var after = node.querySelector('[data-hh-after]');
      if (!before || !after) return;

      if (days > 0) {
        before.textContent = before.textContent.replace('{days}', String(days));
        after.hidden = true;
        before.hidden = false;
      } else {
        before.hidden = true;
        after.hidden = false;
      }
    });
  }

  /* ---------------------------------------------------------- contatori --- */
  /* I numeri salgono da zero: in un prodotto che parla di conteggi è il
     movimento giusto, non un effetto messo a caso. */
  function initCounters() {
    var nums = document.querySelectorAll('[data-hh-count]');
    if (!nums.length || reduce || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);

        var target = parseInt(el.getAttribute('data-hh-count'), 10);
        if (!isFinite(target) || target <= 0) return;

        var suffix = el.textContent.replace(/^[0-9]+/, '');
        var duration = 900;
        var start = null;

        function frame(ts) {
          if (start === null) start = ts;
          var p = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased) + suffix;
          if (p < 1) requestAnimationFrame(frame);
        }

        el.textContent = '0' + suffix;
        requestAnimationFrame(frame);
      });
    }, { threshold: 0.6 });

    nums.forEach(function (el) { observer.observe(el); });
  }

  /* ------------------------------------------------------- traccia 0-6 ---- */
  /* Il bastone si disegna da sinistra a destra quando la traccia entra in vista. */
  function initTrack() {
    var track = document.querySelector('.hh-track');
    if (!track) return;

    if (reduce || !('IntersectionObserver' in window)) {
      track.classList.add('is-drawn');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-drawn');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.25 });

    observer.observe(track);
  }

  /* ------------------------------------------- barra di lettura + parallasse */
  /* Un solo listener sullo scroll per tutto, dentro requestAnimationFrame:
     è la differenza fra una pagina fluida e una che scatta. */
  function initScrollEffects() {
    if (reduce) return;

    var bar = document.createElement('div');
    bar.className = 'hh-progress';
    document.body.appendChild(bar);

    var parallax = Array.prototype.slice.call(document.querySelectorAll('[data-hh-parallax]'));
    var ticking = false;

    function update() {
      ticking = false;

      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      var p = max > 0 ? Math.min(Math.max(window.scrollY / max, 0), 1) : 0;
      bar.style.transform = 'scaleX(' + p + ')';

      var vh = window.innerHeight;
      for (var i = 0; i < parallax.length; i++) {
        var el = parallax[i];
        var rect = el.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > vh + 200) continue;
        // da -1 (sotto la piega) a 1 (sopra): spostamento massimo dodici pixel
        var centred = (rect.top + rect.height / 2 - vh / 2) / vh;
        var amount = Number(el.getAttribute('data-hh-parallax')) || 12;
        el.style.transform = 'translate3d(0,' + (-centred * amount).toFixed(2) + 'px,0)';
      }
    }

    function rescueReveals() {
      var track = document.querySelector('.hh-track:not(.is-drawn)');
      if (track && track.getBoundingClientRect().top < window.innerHeight * 0.95) {
        track.classList.add('is-drawn');
      }
      var titles = document.querySelectorAll('.hh-section h2:not(.is-set)');
      for (var t = 0; t < titles.length; t++) {
        if (titles[t].getBoundingClientRect().top < window.innerHeight * 0.95) titles[t].classList.add('is-set');
      }
      var missed = document.querySelectorAll('.hh-reveal:not(.is-in)');
      for (var i = 0; i < missed.length; i++) {
        var r = missed[i].getBoundingClientRect();
        if (r.top < window.innerHeight * 0.95) missed[i].classList.add('is-in');
      }
    }

    function onScroll() {
      rescueReveals();
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('load', function () { setTimeout(rescueReveals, 1200); });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function init() {
    initReveal();
    initCountdown();
    initCounters();
    initTrack();
    initScrollEffects();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ------------------------------------------------ i pannelli che si aprono --
   Quando un pannello si apre, quello che c'e' dentro viene disegnato per la
   prima volta. Chi aveva gia' misurato qualcosa a pagina chiusa ha misurato
   zero: la mappa, per esempio, calcola quanto spostare i cartigli perche'
   restino dentro lo schermo. Un solo evento di ridimensionamento rimette tutti
   d'accordo, perche' e' quello che ascoltano gia'. */
document.addEventListener('toggle', function (e) {
  var d = e.target;
  if (!d || !d.matches || !d.matches('details.hh-more') || !d.open) return;
  window.dispatchEvent(new Event('resize'));
  /* le comparse in scorrimento dentro il pannello non scatteranno mai, perche'
     l'osservatore le ha gia' viste da nascoste: si mostrano e basta */
  d.querySelectorAll('.hh-reveal').forEach(function (el) { el.classList.add('is-in'); });
}, true);

/* Sul computer i pannelli stanno aperti: la lunghezza della pagina non e' un
   problema, e quello che c'e' dentro va visto senza chiedere un clic.
   Si apre davvero il <details>, non si finge con il foglio di stile: un
   pannello chiuso non viene disegnato, e le immagini pigre dentro non
   partirebbero mai. */
(function () {
  var largo = window.matchMedia('(min-width: 900px)');
  function sistema() {
    document.querySelectorAll('details.hh-more').forEach(function (d) {
      if (largo.matches && !d.open) d.open = true;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sistema, { once: true });
  else sistema();
  if (largo.addEventListener) largo.addEventListener('change', sistema);
})();

/* ------------------------------------------------- il banner del consenso --

   Il banner dei cookie di Shopify e' fisso in fondo allo schermo e, su un
   telefono, e' grande: 351 per 406 pixel su 390 per 844. Finche' la persona
   non risponde, si prende i tocchi di tutto cio' che gli capita sotto.

   Misurato il 2026-09-20 su questo sito, a 390 pixel:
     - copre gli ultimi 25 pixel del bottone d'acquisto (un tocco al centro
       passa, uno sul bordo di sotto finisce sul banner);
     - in fondo alla pagina intrappola i link del piede, perche' li' non si
       puo' scorrere oltre e portarli piu' in alto.

   Rimedio: finche' il banner e' aperto, la pagina si allunga in fondo di
   quanto e' alto il banner. Cosi' qualunque cosa si puo' portare sopra di
   esso scorrendo, e quando la persona risponde lo spazio sparisce.
   Non si tocca il banner: e' di Shopify, e va lasciato fare il suo lavoro. */
(function () {
  var SEL = '.shopify-pc__banner__dialog, .shopify-pc__banner';
  var messo = 0;

  function altezza(el) {
    var r = el.getBoundingClientRect();
    return (r.height > 2 && getComputedStyle(el).display !== 'none') ? Math.ceil(r.height) : 0;
  }

  function sistema() {
    var el = document.querySelector(SEL);
    var h = el ? altezza(el) : 0;
    if (h === messo) return;
    messo = h;
    document.body.style.paddingBottom = h ? h + 'px' : '';
  }

  /* si guarda quando la pagina cambia, quando lo schermo gira, e ogni tanto:
     il banner arriva dopo il resto e puo' sparire in qualunque momento */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sistema, { once: true });
  } else {
    sistema();
  }
  window.addEventListener('resize', sistema);
  try {
    new MutationObserver(sistema).observe(document.body, { childList: true, subtree: true });
  } catch (e) { }
  var conta = 0;
  var battito = setInterval(function () {
    sistema();
    if (++conta > 40) clearInterval(battito);   /* venti secondi, poi bastano gli altri richiami */
  }, 500);
})();
